'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function cbChatExtraInfoDirective() {
    return {
        restrict: 'A',
        scope: true,
        controller: 'chatExtraInfoController',
        controllerAs: 'chatExtraInfoController',
        link: function link($scope, $element) {
            $scope.chatExtraInfoController.setElement($element[0]);
            $scope.chatExtraInfoController.init();
            $scope.chatExtraInfoController.checkExtraInfoPresent = function () {
                $scope.chatExtraInfoController.setExtraInfoPresent(false);
                if ($element[0].innerHTML !== 'dezedivisleeg') {
                    var tipHtmlElement = $($element.html());
                    $(tipHtmlElement).appendTo('#iChatLines');
                    $element.html('dezedivisleeg');
                }
            };

            $scope.$on('$destroy', function () {
                $scope.chatExtraInfoController.observer.disconnect();
            });
        }
    };
}

exports.default = cbChatExtraInfoDirective;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/chat/cb-chat-extra-info.directive.js
// module id = 863
// module chunks = 0